import $ from 'jquery'
import isUndefined from 'lodash-es/isUndefined'

import { isValidDomain, isValidEmail } from './helpers'

import { Forms } from './forms'
import { MessageOverlay } from './message-overlay'
import { Popup } from './popup'
import { resendSignatureConfirmation } from './resend-signature-confirmation'

const Signatures = {
  init: function () {
    Signatures.warnAboutNoreply()

    // Resend confirmation in announcement
    $(document).on('click', '.js-announce-resend', Signatures.resendAnnounce)

    // Add domain modal form
    $(document).on('submit', '.js-add-domain', Signatures.addDomain)

    // Verify DNS record
    $(document).on('click', '.js-dns-verify', Signatures.verifyRecord)

    // Generate new DKIM record
    $(document).on('click', '.js-new-dkim', Signatures.newDkim)

    // Remove new DKIM record
    $(document).on('click', '.js-remove-new-dkim', Signatures.removeNewDkim)

    // Send instructions to teammate
    $(document).on(
      'submit',
      '.js-dns-instructions-form',
      Signatures.instructionsForm
    )

    // Include personal message to teammate
    $(document).on(
      'click',
      '.js-dns-instructions-show-message',
      Signatures.showMessage
    )

    // Start editing return-path hostname
    $(document).on('click', '.js-dns-edit-rp', Signatures.editReturnpath)

    // Stop editing return-path hostname
    $(document).on('click', '.js-dns-cancel-rp', Signatures.cancelReturnPath)

    // Saving return-path hostname
    $(document).on('submit', '.js-dns-rp-form', Signatures.saveNewReturnPath)
  },

  saveNewReturnPath: function (event) {
    event.preventDefault()
    const $el = $('.c-dns-edit-rp')
    const $record = $el.parents('.c-dns-row')
    const $loader = $('.js-dns-rp-loading')
    const $error = $('.js-dns-rp-error')
    const newReturnPath = $el.find('.u-input').val()

    // Only save new return-path if the hostname changed
    if (
      Signatures.initialReturnPath !== newReturnPath &&
      newReturnPath !== ''
    ) {
      $loader.removeClass('is-hidden')

      // Reset error state
      $error.remove()
      $el.find('.u-input').removeClass('is-invalid').attr('aria-invalid', false)

      $.ajax({
        url: $(this).attr('action'),
        method: 'PATCH',
        data: $(this).serialize(),
      })
        .done(function () {
          // Update hostname label
          $('.js-dns-rp-hostname').text(
            newReturnPath + $('.js-dns-subdomain').text()
          )

          // Hide RP form
          $el.addClass('is-hidden')
          $loader.addClass('is-hidden')

          // Reset state back to inactive
          Signatures.updateRecordState(
            $record,
            true,
            'c-dns-row--inactive',
            'Inactive'
          )

          // Hide visible message and verify button
          $record.find('.c-dns-row_message').remove()
          $record.find('.js-dns-verify').removeClass('is-hidden')

          Signatures.toggleInstructions()
        })
        .fail(function (response) {
          const data = response.responseJSON

          // Generate error label
          const $label = $('<p />').addClass(
            'c-error-tooltip c-dns-edit-rp_error js-dns-rp-error'
          )

          // Check whether there's a message in the response
          if (!isUndefined(data) && data.status === 'Error') {
            $label.text(data.error)
          } else {
            // In case it's a catastrophic error and the server doesn't return anything
            $label.text(
              'There was an issue saving your custom Return-Path hostname. Please try again.'
            )
          }

          // Show the error state
          $el.append($label)
          $el.find('.u-input').addClass('is-invalid').attr('aria-invalid', true)
        })
        .always(function () {
          // Hide loader
          $loader.addClass('is-hidden')

          // Re-enable submit Save button
          $el.find('input[type="submit"]').prop('disabled', false)
        })
    } else {
      // If the hostname didn't change just hide the form
      $el.addClass('is-hidden')
      $el.find('.u-input').val(Signatures.initialReturnPath)
    }
  },

  editReturnpath: function (event) {
    event.preventDefault()

    const $el = $('.c-dns-edit-rp')
    const $input = $el.find('.u-input')

    // Keep track of initial return path
    Signatures.initialReturnPath = $input.val()

    // Show form
    $el.removeClass('is-hidden')

    // Highlight input text
    $input.trigger('select')

    // Enable submit button
    $el.find('input[type="submit"]').prop('disabled', false)
  },

  cancelReturnPath: function (event) {
    event.preventDefault()

    const $el = $('.c-dns-edit-rp')
    const $input = $el.find('.u-input')

    // Hide form
    $el.addClass('is-hidden')

    // Reset input
    $input.val(Signatures.initialReturnPath).removeClass('is-invalid')

    // Remove any error labels
    $('.c-dns-edit-rp_error').remove()
  },

  instructionsForm: function (event) {
    event.preventDefault()

    const $form = $(this)

    const $recipientEmailRow = $form.find(
      '.js-dns-instructions-recipient-email'
    )
    const $replyToRow = $form.find('.js-dns-instructions-reply-to')
    const recipientEmail = $.trim($recipientEmailRow.find('.u-input').val())
    const replyToEmail = $.trim($replyToRow.find('.u-input').val())

    // 1. Validate the form
    const validRecipient = isValidEmail(recipientEmail)
    const validReplyTo = replyToEmail === '' || isValidEmail(replyToEmail)

    if (validRecipient) {
      Forms.removeError($recipientEmailRow)
    } else {
      Forms.showError($recipientEmailRow, 'Please enter a valid email.')
    }

    if (validReplyTo) {
      Forms.removeError($replyToRow)
    } else {
      Forms.showError($replyToRow, 'Please enter a valid email.')
    }

    if (!(validRecipient && validReplyTo)) return

    // 2. Submit the form
    $form.addClass('u-is-loading')
    $.ajax({
      url: $form.attr('action'),
      method: 'POST',
      data: $form.serialize(),
    })
      .done(function () {
        // Close popup and show success message
        Popup.close(event)
        MessageOverlay.show(
          `We sent the DNS instructions to ${recipientEmail}.`
        )
      })
      .fail(function () {
        Forms.showError(
          $replyToRow,
          'There was an issue sending the instructions to your teammate. Please try again.'
        )
      })
      .always(function () {
        $form.removeClass('u-is-loading')
      })
  },

  showMessage: function (event) {
    event.preventDefault()

    // Hide link
    $(this).hide()

    // Show textarea
    $('.js-dns-instructions-message').slideDown(100).find('.u-input').focus()
  },

  verifyRecord: function (event) {
    event.preventDefault()
    const $button = $(this)
    const $parent = $button.parents('.c-dns-row')

    // Show verifying state
    $button.addClass('is-loading')
    Signatures.updateRecordState($parent, false, 'is-verifying', 'Verifying')

    // Verify record with server
    $.ajax({
      url: $button.attr('href'),
      type: 'PUT',
    })
      .done(function (response) {
        // If the record is verified
        if (response.status === 'ok') {
          Signatures.updateRecordState(
            $parent,
            true,
            'c-dns-row--verified',
            'Verified'
          )
          Signatures.updateBenefitBlock(response)

          // Remove verification button
          $button.hide()

          // Check if this is a DKIM record
          if ($parent.attr('data-record-type') === 'dkim') {
            // Show the Generate new DKIM button

            //$('.js-new-dkim').removeClass('is-hidden');

            // Revoke the old DKIM record if it exists
            const $activeRecord = $parent.siblings(
              '.c-dns-row--verified[data-record-type="dkim"]'
            )
            $activeRecord.find('.js-new-dkim').remove()
            $activeRecord
              .removeClassPrefix('c-dns-row--')
              .addClass('c-dns-row--unverified')
              .find('.c-dns-row_record-status')
              .text('Revoked')
          }

          Signatures.toggleInstructions()
        } else if (response.status === 'failed') {
          Signatures.updateRecordState(
            $parent,
            true,
            'c-dns-row--unverified',
            'Unverified'
          )
        }

        Signatures.showRecordMessage($parent, response.description)
        $button.removeClass('is-loading')
      })
      .fail(function () {
        $button.removeClass('is-loading')
        Signatures.updateRecordState(
          $parent,
          true,
          'c-dns-row--inactive',
          'Inactive'
        )
        MessageOverlay.show(
          'Yikes! There was a problem verifying this domain.',
          'error',
          25000
        )
      })
  },

  updateBenefitBlock: function (response) {
    setTimeout(function () {
      // Update verification block
      if (response.verification_html) {
        $('.js-dns-benefit-verification').replaceWith(
          response.verification_html
        )
        $('.js-dns-domain').addClass('c-domain-title--verified')
      }

      // Update authentication block
      if (response.authentication_html) {
        $('.js-dns-benefit-authentication').replaceWith(
          response.authentication_html
        )
      }
    }, 700)
  },

  updateRecordState: function ($record, removeMod, newClass, statusLabel) {
    // Remove class modifier
    if (removeMod) $record.removeClassPrefix('c-dns-row--')

    $record
      .removeClassPrefix('is-') // Remove state classes
      .addClass(newClass) // Add the new class
      .find('.c-dns-row_record-status')
      .text(statusLabel) // Update status label
  },

  showRecordMessage: function ($record, message) {
    const $existing = $record.find('.c-dns-row_message')

    // Check if there's an existing message
    if ($existing.length > 0) {
      $existing.html(message)
    } else {
      const $newMessage = $('<div></div>')
        .addClass('c-dns-row_message')
        .attr('role', 'alert')
        .hide()
        .html(message)

      $record.append($newMessage)
      $newMessage.slideDown(100)
    }
  },

  newDkim: function (event) {
    event.preventDefault()

    const $button = $(this)
    $button.addClass('is-loading')
    $('.c-dns-row_message').slideUp(100)

    // Make request
    $.ajax({
      url: $button.attr('href'),
      type: 'PUT',
    })
      .done(function (response) {
        const rowClass = '.c-dns-row'

        // Append new record to table and animate it
        $button
          .hide()
          .parents(rowClass)
          .after(response)
          .next(rowClass)
          .slideDown(100)

        Signatures.toggleInstructions()
      })
      .fail(function () {
        $button.removeClass('is-loading')
        MessageOverlay.show(
          'Yikes! There was a problem generating a new DKIM record.',
          'error',
          25000
        )
      })
  },

  toggleInstructions: function () {
    if (
      $('[data-record-type="dkim"]').hasClass('c-dns-row--inactive') ||
      $('[data-record-type="rp"]').hasClass('c-dns-row--inactive')
    ) {
      $('.js-instructions').removeClass('is-hidden')
    } else {
      $('.js-instructions').addClass('is-hidden')
    }
  },

  removeNewDkim: function (event) {
    event.preventDefault()

    const $button = $(this)
    $button.addClass('is-loading')

    // Make request
    $.ajax({
      url: $button.attr('href'),
      type: 'POST',
    })
      .done(function () {
        // Animate and remove record
        $button.parents('.c-dns-row').slideUp(100, function () {
          $(this).remove()

          // Show the generate new button on the other DKIM record
          $('.js-new-dkim').removeClass('is-loading is-hidden').show()
          Signatures.toggleInstructions()
        })
      })
      .fail(function () {
        $button.removeClass('is-loading')
        MessageOverlay.show(
          'Yikes! There was a problem removing this DKIM record.',
          'error',
          25000
        )
      })
  },

  addDomain: function (event, isValid) {
    isValid = isValid || false

    if (!isValid) {
      event.preventDefault()

      const $form = $(this)
      $form.addClass('u-is-loading')

      const domain = $('.js-domain-input').val()

      // Make sure domain isn't blank
      if (domain !== '') {
        // Check domain format
        if (!isValidDomain(domain)) {
          Signatures.showDomainError(
            $form,
            'This doesn’t look like a domain name. ex. yourdomain.com.'
          )
        } else {
          // Send request to server
          Signatures.addDomainRequest($form, event)
        }
      } else {
        Signatures.showDomainError($form, 'The domain can’t be blank.')
      }
    }
  },

  addDomainRequest: function ($form) {
    $.ajax({
      url: $form.data('validation-uri'),
      type: 'POST',
      data: $form.serialize(),
    })
      .done(function (response) {
        if (response.status === 'redirect') {
          window.location.href = response.location
        } else {
          // Submit form and keep validation from firing again
          $form.trigger('submit', [true])
        }
      })
      .fail(function (response) {
        Signatures.showDomainError(
          $form,
          JSON.parse(response.responseText).message
        )
      })
  },

  showDomainError: function ($form, message) {
    $form.removeClass('u-is-loading')
    Forms.showError($form.find('.c-form-row'), message)
  },

  warnAboutNoreply: function () {
    $('.js-no-reply').each(function () {
      const input = $(this),
        warning = $(
          '<div class="c-form-row_warning"><p><strong>No-reply emails are not recommended.</strong> Read more <a href="https://postmarkapp.com/blog/no-no-reply">on our blog</a>.</p></div>'
        )

      function check() {
        if (
          input.val().search(/no-reply/i) !== -1 ||
          input.val().search(/noreply/i) !== -1
        ) {
          return true
        } else {
          return false
        }
      }

      function warn() {
        input.parents('.c-form-row').find('.c-form-row_field').after(warning)
      }

      if (check()) {
        warn()
      }

      input.keyup(function () {
        if (check()) {
          warn()
        } else {
          input.parents('.c-form-row').find('.c-form-row_warning').remove()
        }
      })
    })
  },

  resendAnnounce: async function (event) {
    event.preventDefault()

    const $el = $(this)
    const $announcement = $el.parents('.js-announcement')

    if ($announcement.hasClass('u-is-loading')) return

    $announcement.addClass('u-is-loading')
    try {
      const response = await resendSignatureConfirmation(
        $el.data('signatureId')
      )

      $announcement
        .find('.announcement_message')
        .text(response.message)
        .siblings('.announcement_actions')
        .remove()
    } catch (e) {
      MessageOverlay.show(e.message || e, 'error')
    } finally {
      $announcement.removeClass('u-is-loading')
    }
  },
}

$(Signatures.init)
